export default {
  GOODS_MANAGEMENT_LSIT: Symbol('GOODS_MANAGEMENT_LSIT'),
  GOODS_LAUNDREY_LSIT: Symbol('GOODS_LAUNDREY_LSIT'),
  UPDATE_GOODS_MANAGEMENT_STATE: Symbol('UPDATE_GOODS_MANAGEMENT_STATE'),
  GOODS_ROOMS_LSIT: Symbol('GOODS_ROOMS_LSIT'),
  SET_GOODS_SEARCH_VALUE: Symbol('SET_GOODS_SEARCH_VALUE'),
  SET_LAUNDRY_SEARCH_VALUE: Symbol('SET_LAUNDRY_SEARCH_VALUE'),
  ROOM_LIST: Symbol('ROOM_LIST'),
  SET_EXPORT_BTN_LOADING: Symbol('SET_EXPORT_BTN_LOADING'),
  SET_FILTER_GOODS_OBJ: Symbol('SET_FILTER_GOODS_OBJ'),
  INTRO_GOODS_LIST: Symbol('INTRO_GOODS_LIST'),
  RESET_GOODS_INTRO_DATA: Symbol('RESET_GOODS_INTRO_DATA'),
};
